import { render, staticRenderFns } from "./ConfirmRefuseDeleteUser.vue?vue&type=template&id=04b50ad0"
import script from "./ConfirmRefuseDeleteUser.vue?vue&type=script&lang=js"
export * from "./ConfirmRefuseDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports